export default __webpack_public_path__ + "static/media/yellow.4b0ef959.svg";